/**
 * Authentication related colors (forgot password, security question, password validation, pin auth)
 */
import { palette, createColor } from './palette.colors';

export const forgotPasswordColors = {
  subHeaderText: createColor(palette.blue.onTint, palette.gray.white),
  messageText: createColor(palette.gray.darkest, palette.gray.white),
  backCTAColor: createColor(palette.gray.darkest, palette.gray.white),
  backIcon: createColor(palette.gray.black, palette.gray.white),
};

export const securityQuestionColors = {
  BG: createColor(palette.gray.almostWhite, palette.gray.security),
  border: createColor(palette.gray.border, palette.dark.borderLight),
  icon: createColor(palette.gray.white, palette.gray.black),
  iconBG: createColor(palette.ui.hoverBlue, palette.gray.white),
  text: createColor(palette.gray.darker, palette.gray.white),
  subText: createColor(palette.gray.darkest, palette.gray.text),
};

export const passwordValidationColors = {
  listBg: createColor(palette.gray.veryLight, palette.gray.white),
  listBorder: createColor(palette.gray.border, palette.gray.white),
  tickIcon: createColor(palette.gray.smoke, palette.gray.white),
  tickIconCommon: createColor(palette.gray.smoke, palette.gray.smoke),
};

export const pinAuthColors = {
  overlayBackground: createColor(palette.opacity.overlayDark, palette.opacity.overlayDark),
  background: createColor(palette.gray.white, palette.dark.background),
  titleColor: createColor(palette.blue.onTint, palette.dark.textAlt),
  subtitleColor: createColor(palette.blue.onTint, palette.dark.textAlt),
  technicianNameColor: createColor(palette.blue.onTint, palette.dark.text),
  technicianRoleColor: createColor(palette.blue.onTint, palette.dark.textAlt),
  technicianLocationColor: createColor(palette.gray.lightDarkGrey, palette.dark.textAlt),
  iconBackground: createColor(palette.blue.tint, palette.gray.iconLight),
  pinInputBorder: createColor(palette.gray.neutral, palette.gray.neutral),
  pinErrorInputBorder: createColor(palette.semantic.darkRed, palette.semantic.darkRed),
  pinInputText: createColor(palette.gray.veryDark, palette.dark.text),
  pinInputErrorText: createColor(palette.gray.darkest, palette.dark.text),
  pinErrorInputText: createColor(palette.gray.darkest, palette.dark.text),
  techniciaInfoBG: createColor(palette.gray.techInfo, palette.dark.content),
  techniciaInfoBorder: createColor(palette.special.transparent, palette.borders.tech),
  backCTABGColor: createColor(palette.gray.white, palette.gray.white),
  backCTABorderColor: createColor(palette.gray.neutral, palette.gray.neutral),
  iconBGColor: createColor(palette.blue.primary, palette.blue.primary),
  closeIconColor: createColor(palette.blue.onTint, palette.dark.textAlt),
  authenticationEyeText: createColor(palette.blue.onTint, palette.dark.textAlt),
  openEyeIcon: createColor(palette.blue.onTint, palette.dark.textAlt),
  closeEyeIcon: createColor(palette.blue.onTint, palette.dark.textAlt),
  pinAuthBorderColor: createColor(palette.blue.primary, palette.blue.primary),
};

export const pinInputColors = {
  BG: createColor(palette.blue.selectedItemBG, palette.blue.selectedItemBG),
  border: createColor(palette.blue.selectedBorder, palette.blue.selectedBorder),
  errorBG: createColor(palette.opacity.red13, palette.opacity.red13),
};

export const logout = {
  closeIcon: createColor(palette.blue.onTint, palette.gray.dark),
}